import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { StripePaymentOnboardingContainer as StripePaymentOnboardingPopup } from './stripe-payment-onboarding/stripe-payment-onboarding-container';
import { AccountRestrictedSoonContainer as AccountRestrictedSoonPopup } from './account-restricted-soon/account-restricted-soon-container';
export var StripePopups = function () {
    return (_jsxs(_Fragment, { children: [_jsx(StripePaymentOnboardingPopup, {}), _jsx(AccountRestrictedSoonPopup, {})] }));
};
